import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PanVerificationPage } from './pan-verification.page';

const routes: Routes = [
  {
    path: '',
    component: PanVerificationPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PanVerificationPageRoutingModule {}
